package ar.corzo.health_tracker.connections

import io.ktor.client.engine.HttpClientEngineConfig
import io.ktor.client.engine.HttpClientEngineFactory
import io.ktor.client.engine.js.Js

actual val engineClient: HttpClientEngineFactory<HttpClientEngineConfig> = Js